import React, { FC } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum } from "@/utils/utils";
import { useSalesDetailModel } from "../salesDetailModel";
import { ISalesDetailMethod } from "@/views/sales/salesTypes";

// 收汇方式
export const TableBoxMethod: FC<RouterParamType> = ({ id, mode }) => {
    const { editMethodList,
        addFormVal,
        editFormVal,
        setEditMethodList, addMethodList, setAddMethodList, addMethod, getcurrencySymbol
    } = useSalesDetailModel(({ editMethodList, addMethodList, addFormVal, editFormVal, }) => [editMethodList, addMethodList, addFormVal, editFormVal,]);
    const { getSelectedDictOne, getTreeNodeName, getSelectedDictValueOne, getTreeNodeValue } = useDictModel(() => []);
    const methodList = mode === "edit" ? editMethodList : addMethodList;
    const setMethodList = mode === "edit" ? setEditMethodList : setAddMethodList;
    const formVal = mode === "edit" ? editFormVal : addFormVal;

    const columns = [
        {
            title: '操作',
            width: 60,
            fixed: "left",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: any, i: number) =>
                record.key === "totalAmount" ?
                    "" : <>
                        <YhBut
                            type="add"
                            txt="添加"
                            click={() => addMethod(mode)}
                            disabled={formVal.status ==='sales.ship'}
                        />
                        <YhBut
                            type="delete"
                            txt="删除"
                            disabled={methodList.length <= 1 ||formVal.status ==='sales.ship'}
                            click={() => setMethodList(origin => origin.filter(item => item.key !== record.key))}
                        />
                    </>
        }, {
            title: '序号',
            width: 45,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '*货前后',
            width: 160,
            dataIndex: 'around',
            // editable: true,
            editable:formVal.status!=='sales.ship',
            editType: "select",
            options: getSelectedDictOne(DictCodeEnmu.DEIIVERY),
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '*收汇方式',
            width: 160,
            dataIndex: 'paymentMethod',
            // editable: true,
            editable:formVal.status!=='sales.ship',
            editType: "select",
            options: getSelectedDictOne(DictCodeEnmu.COLLECT_METHOD),
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '日期方式',
            width: 160,
            dataIndex: 'paymentTime',
            // editable: true,
            editable:formVal.status!=='sales.ship',
            editType: "select",
            options: getSelectedDictOne(DictCodeEnmu.DATE_TYPE),
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '天数',
            width: 120,
            dataIndex: 'days',
            // editable: true,
            editable:formVal.status!=='sales.ship',
        }, {
            title: '比例%',
            width: 160,
            dataIndex: 'proportion',
        }, {
            title: '*金额',
            width: 160,
            // editable: true,
            editable:formVal.status!=='sales.ship',
            dataIndex: 'amount',
            render: (text: any) => `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        }, {
            title: '预计收款日期',
            width: 160,
            dataIndex: 'collectionTime',
            // editable: true,
            editable:formVal.status!=='sales.ship',
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        }, {
            title: '预计收证日期',
            width: 160,
            dataIndex: 'certificatesTime',
            // editable: true,
            editable:formVal.status!=='sales.ship',
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        },
    ];

    const newColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISalesDetailMethod, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: ISalesDetailMethod) => {
        //合同总金额
        let contractAmount = +formatNum(formVal.contractAmount);
        row.amount = formatNum(row.amount);
        row.proportion = `${formatNum(+row.amount / contractAmount * 100)}%`
        let dataSource = [...methodList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setMethodList(dataSource);
    }

    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        ename: "",
        name: "",
        amount: methodList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0)
    }

    return (
        <YhBox title="收汇方式" style={{ marginBottom: "10px", width: "100%" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumns as ColumnsType<ISalesDetailMethod>}
                dataSource={methodList.length > 0 ? [...methodList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    )
}